import ApiRequestBuilder from '../ApiService/Request/ApiRequestBuilder';


const API_PATH_AUTH_BASE = '/auth';
const API_PATH_REGISTRATION_CREATE = `${API_PATH_AUTH_BASE}/register`;


class AuthService {

    /**
     * @type {ApiService}
     */
    apiService;

    /**
     * @type {string} Bearer token
     */
    token;


    /**
     * @param apiService {ApiService}
     */
    constructor(apiService) {

        this.apiService = apiService;
    }


    /**
     * @return {string|null}
     */
    getToken() {

        return this.token;
    }


    /**
     * @param token {string|null}
     */
    setToken(token) {

        this.token = token;
    }


    /**
     * @param registrationData  {object}
     */
    async registerUser(registrationData) {

        const registrationRequest = ApiRequestBuilder.post(API_PATH_REGISTRATION_CREATE)
            .json()
            .body(registrationData)
            .build();

        return this.apiService.execute(registrationRequest);
    }
}

export default AuthService;
